import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CrossProductActionState, CrossProductActionParams } from './types';
import { RootState } from '../config/rootReducer';

const initialState: CrossProductActionState = {
  params: null,
};

const crossProductActionSlice = createSlice({
  name: 'crossProductAction',
  initialState,
  reducers: {
    setParams(state, action: PayloadAction<CrossProductActionParams>) {
      state.params = action.payload;
    },
    clearParams(state) {
      state.params = null;
    },
  },
});

export const { setParams, clearParams } = crossProductActionSlice.actions;

export const selectCrossProductParams = (state: RootState) =>
  state.crossProductAction.params;

export default crossProductActionSlice.reducer;
